import type { UseFormReturnType } from '@mantine/form';
import { useEffect } from 'react';
import type { UseMutationResult } from 'react-query';
import type { ApiResponse } from '../../../util/types/Response';

export function useServerAccountValidation<T>(
    staffMutation: UseMutationResult<
        ApiResponse<any>,
        unknown,
        void,
        unknown
    >,
    form: UseFormReturnType<T, (values: T) => T>,
) {
    useEffect(() => {
        if (!staffMutation.data?.isValid) {
            // biome-ignore lint/complexity/noForEach: <explanation>
            staffMutation.data?.validationMessages.forEach((v) => {
                if (v.inputIdentifier === 'Username') {
                    form.setFieldError('username', v.validationMessage);
                }
            });
        }
    }, [staffMutation.data?.validationMessages]);
}
